import React from 'react';
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputLabelContainer } from '../../../../common/components/form/label/containers/input-label.container';

export const GlobalRegistriesKeypairInfoComponent = ({ selectedDbnpRegistry }: any) => (
    <>
        <AccordionContainer
            child={
                <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                   <div>
          <InputLabelContainer
              label="Encrypted Public Key"
          />
          <InputLabelContainer
              label={selectedDbnpRegistry?.encr_public_key}
          />
    </div>
    <div>
          <InputLabelContainer
              label="Signing Public Key"
          />
          <InputLabelContainer
              label={selectedDbnpRegistry?.signing_public_key}
          />
    </div>
                </div>
            }
            expandedPanel="Signed KeyPair Info"
            headerTitle="Signed KeyPair Info"
        />
       
    </>
)

export default GlobalRegistriesKeypairInfoComponent;